import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import InputWidget from './InputWidget';

/**
 * Stellt eine Einzelauswahl als <select> Eingabe dar.
 */
class SelectControl extends InputWidget {
    render() {
        return (
            <Form.Group>
                <Form.Label>{this.renderLabelText()}</Form.Label>
                <Form.Control as="select"
                              name={this.getFieldName()}
                              value={this.getValue()}
                              isInvalid={this.isInvalid()}
                              onChange={this.handleChange}
                              onBlur={this.handleBlur}
                              disabled={this.props.disabled}
                              data-testid={this.props.widget.id}
                >
                    {/* Es muss der index als key genommen werden, da nicht garantiert ist,
                        dass label oder value der choice eindeutig sind. */}
                    {this.props.options.map(({label, value}, index) => (
                        <option key={index} value={value}>{label}</option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                    {this.getError()}
                </Form.Control.Feedback>
                {this.getCustomRequiredError()}
            </Form.Group>
        );
    }
}

SelectControl.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
    }))
};

export default SelectControl;
